$('[name="birth_date"]').mask('00/00/0000');
$('[name="number"]').mask('000000');
$('[name="zipcode"]').mask('00000-000');

if ($('.is-invalid').length) {
    $(window).scrollTop($('.is-invalid:eq(0)').parents('.row').offset().top - 60);
}

$('[name="zipcode"]').blur(function() {

    if($('[name="country"]').val() == 'BRA') {

        var cep = $(this).val().replace(/\D/g, '');
        if (cep != '') {
            var validacep = /^[0-9]{8}$/;
            if (validacep.test(cep)) {
                $.getJSON('https://viacep.com.br/ws/'+ cep +'/json/?callback=?', function(dados) {

                    if(!('erro' in dados)) {

                        if(dados.logradouro != '') {
                            $('[name="address"]').val(dados.logradouro).attr('readonly', true);
                        } else {
                            $('[name="address"]').attr('readonly', false);
                        }

                        if(dados.bairro != '') {
                            $('[name="neighborhood"]').val(dados.bairro).attr('readonly', true);
                        } else {
                            $('[name="neighborhood"]').attr('readonly', false);
                        }

                        $('[name="city"]').val(dados.localidade).attr('readonly', true);
                        $('[name="state"]').val(dados.uf);
                        $('[name="select_state"]').val(dados.uf).attr('disabled', true);
                        $('[name="number"]').focus();

                        $('[name="zipcode"]').parents('.form-group').find('.invalid-feedback').remove();
                        $('[name="zipcode"]').removeClass('is-invalid');

                        $('[name="address"]').parents('.form-group').find('.invalid-feedback').remove();
                        $('[name="address"]').removeClass('is-invalid');

                        $('[name="neighborhood"]').parents('.form-group').find('.invalid-feedback').remove();
                        $('[name="neighborhood"]').removeClass('is-invalid');

                        $('[name="city"]').parents('.form-group').find('.invalid-feedback').remove();
                        $('[name="city"]').removeClass('is-invalid');

                        $('[name="select_state"]').parents('.form-group').find('.invalid-feedback').remove();
                        $('[name="select_state"]').removeClass('is-invalid');


                    } else {
                        $('[name="address"]').val('').attr('readonly', false);
                        $('[name="neighborhood"]').val('').attr('readonly', false);
                        $('[name="city"]').val('').attr('readonly', false);
                        $('[name="state"]').val('');
                        $('[name="select_state"]').val(dados.uf).attr('disabled', false);
                    }
                }).fail(function() {
                    $('[name="address"]').val('').attr('readonly', false);
                    $('[name="neighborhood"]').val('').attr('readonly', false);
                    $('[name="city"]').val('').attr('readonly', false);
                    $('[name="state"]').val('');
                    $('[name="select_state"]').val(dados.uf).attr('disabled', false);
                });
            }
        }
    }

}).trigger('blur');

$('[name="select_state"]').on('change', function() {
    var $this = $(this);
    $('[name="state"]').val($this.val());
});

var SPMaskBehavior = function (val) {
    return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
}, spOptions = {
    onKeyPress: function(val, e, field, options) {
        field.mask(SPMaskBehavior.apply({}, arguments), options);
    }
};

if(lang == 'pt') {
    $('[name="cellphone"]').mask(SPMaskBehavior, spOptions);
}

if(lang == 'en') {
    $('[name="cellphone"]').mask('9999999999999999999999999');
}

$('[name="country"]').on('change', function() {

    if($(this).val() == 'BRA') {
        $('[name="address"]').val('').attr('readonly', true);
        $('[name="neighborhood"]').val('').attr('readonly', true);
        $('[name="city"]').val('').attr('readonly', true);
        $('[name="state"]').val('');
        $('[name="select_state"]').val('').attr('disabled', true).show();
        $('[name="state"]').attr('type', 'hidden').hide();
        $('[name="zipcode"]').mask('00000-000');
    } else {
        $('[name="address"]').val('').attr('readonly', false);
        $('[name="neighborhood"]').val('').attr('readonly', false);
        $('[name="city"]').val('').attr('readonly', false);
        $('[name="state"]').val('');
        $('[name="select_state"]').val('').attr('disabled', false).hide();
        $('[name="state"]').attr('type', 'text').show();
        $('[name="zipcode"]').unmask();
    }
});

$('[name="country_of_birth"]').on('change', function() {
    if($(this).val() == 'BRA') {
        $('[name="select_state_of_birth"]').val('').attr('disabled', false).show();
        $('[name="state_of_birth"]').val('').attr('type', 'hidden').hide();
    } else {
        $('[name="select_state_of_birth"]').val('').attr('disabled', true).hide();
        $('[name="state_of_birth"]').val('').attr('type', 'text').show();
    }
});

$('[name="select_state_of_birth"]').on('change', function() {
    var $this = $(this);
    $('[name="state_of_birth"]').val($this.val());
});

//modal politica
$('.btn-modal-privacy-policy').on('click', function(e){
    e.preventDefault();

    $('.modal-privacy').fadeIn();
    $('body').addClass('overflow');
})

function closeModal () {
    $('.modal-privacy').fadeOut();
    $('body').removeClass('overflow');
}

$('.modal-privacy').on('click', function(e) {
    if ($(e.target).closest('.modal-content').length == 0) {
        closeModal();
    }
});

$('.modal-privacy button').on('click', function() {
    closeModal();
});

$(document).keyup(function(e) {
    if (e.key === "Escape") { // escape key maps to keycode `27`
        closeModal();
    }
});
